import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export class ContentDoesNotExistError extends CodedError {
  static get errorName() {
    return errorCodes.contentDoesNotExistError.code;
  }

  constructor(message: string = errorCodes.contentDoesNotExistError.message) {
    super(message);
    this.code = errorCodes.contentDoesNotExistError.code;
    this.message = `${message} ${errorCodes.contentDoesNotExistError.code}`;
    this.name = errorCodes.contentDoesNotExistError.name;
    this.status = errorCodes.contentDoesNotExistError.status;
  }
}
